import { createSlice } from "@reduxjs/toolkit";
/* 
Role and Permission have the camp dropdown , so we created the SettingSlice
*/
export const settingsSlice = createSlice({
  name: "settings",
  initialState: {
    organization: "",  
    camp:{},
  },
  reducers: {
    updateSettingsCamp(state, action) {
      state.camp = action.payload;
    },
  },
});

export const {updateSettingsCamp } =
  settingsSlice.actions;

export default settingsSlice.reducer;
